<template>
  <div>
    <v-snackbar
      class="mt-5 snack-text-center"
      :color='color'
      :timeout="3000"
      :top="true"
      v-model="alert"
    >{{message}}</v-snackbar>

    <!-- <v-container class="verification-link" v-if="resendLink" >
      <v-layout row>
        <v-flex xs6 offset-xs3>
          <v-card class="border-all-1 corner-all-10 box_s container">
            <h3>Verification Expired</h3>
            <v-card-text class="pl0">
              Your verification link is expired, Please try sending verification link again from the button below.
            </v-card-text>
            <v-card-actions class="pl0">
              <v-btn color="primary" @click="resendVerificationLink">Resend</v-btn>
            </v-card-actions>
          </v-card>
          <!-+- <h4 class="text-center" v-if="remaining" >Remaining Attempts: {{remainingAttempts}}</h4> -->
          <!-- <div class="p10" v-if="remaining">You have {{remainingAttempts}} attempts remaining</div> --+>
        </v-flex>
      </v-layout>
    </v-container> -->
    <v-container class="verification-link">
      <v-layout row>
        <v-flex xs6 offset-xs3>
          <v-card class="border-all-1 corner-all-10 box_s container">
            <h3>User Verification</h3>
            <v-card-text class="pl0">
              <v-text-field
                v-model="user_email"
                label="Email"
                v-validate="'required'"
                data-vv-name="email"
                disabled
                :error-messages="errors.collect('email')"
              ></v-text-field>
              <v-text-field
                v-model="emailVerifyCode"
                label="Verification Code"
                v-validate="{required: true, alpha_num: true}"
                data-vv-name="code"
                :error-messages="errors.collect('code')"
              ></v-text-field>
              <div v-if="isMobileRequired && emailVerified">
                <p class="pt10">
                  A one time password has been sent to your mobile number. Enter the password to verify.
                </p>
                <v-text-field
                  v-model="OTP"
                  label="OTP"
                  v-validate="{required: true, integer: true}"
                  data-vv-name="otp"
                  :error-messages="errors.collect('otp')"
                ></v-text-field>
                <span v-if='counterMessage' class='pb-0'>You can request another OTP in <strong>{{countDown}}</strong> sec</span>
                <p v-if='showResendBtn' class="text-primary-apiculus link disFlex align-center" @click='resendOTP()'><v-icon class="text-primary-apiculus">replay</v-icon> Resend OTP</p>
              </div>

            </v-card-text>
            <v-card-actions class="pl0">
              <vue-recaptcha v-if="!(isMobileRequired && emailVerified)" id="recaptcha" ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" :sitekey="recaptchaSiteKey" size="invisible">
              </vue-recaptcha>
              <v-btn color="primary" :disabled="!verificationCodeValid" v-if="!(isMobileRequired && emailVerified)" @click="initiateEmailVerification()">Verify Email</v-btn>
              <v-btn color="primary" v-else :disabled="!otpValid" @click="verifyOTP()">Verify OTP</v-btn>
            </v-card-actions>
          </v-card>
          <!-- <h4 class="text-center" v-if="remaining" >Remaining Attempts: {{remainingAttempts}}</h4> -->
          <div class="p10" v-if="remaining">You have {{remainingAttempts}} attempts remaining</div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'EmailVerification',
  components: { VueRecaptcha },
  data: () => ({
    color: '',
    alert: false,
    message: '',
    resendLink: false,
    errorMeta: {},
    remaining: false,
    remainingAttempts: '',
    user_email: '',
    emailVerifyCode: '',
    emailVerified: false,
    emailVerificationRes: {},
    OTP: '',
    showResendBtn: true,
    counterMessage: false,
    countDown: '',
    recaptcha_response: ''
  }),
  computed: {
    getUserEmail () {
      // console.log(this.$route, this.$route.query.email)
      return this.$route.query.email || ''
    },
    isMobileRequired () {
      return (this.$store.state.ApiculusEnv && this.$store.state.ApiculusEnv.mobileRequired) || Boolean(false)
    },
    verificationCodeValid () {
      // console.log(this.emailVerifyCode && this.fields.code && this.fields.code.valid)
      return this.emailVerifyCode && this.fields && this.fields.code && this.fields.code.valid
    },
    otpValid () {
      // console.log(this.OTP , ' -- ', this.fields.otp)
      return this.OTP && this.fields && this.fields.otp && this.fields.otp.valid
    },
    counterTime () {
      return this.$store.state.ApiculusEnv.OTPTimer || 20
    },
    recaptchaSiteKey () {
      return JSON.parse(localStorage.getItem('ApiculusEnv')).siteKey
    }
  },
  mounted () {
    this.user_email = this.getUserEmail
    this.countDown = this.counterTime
  },
  methods: {
    otpTimer () {
      let interval = setInterval(() => {
        this.countDown--
        if (this.countDown <= 0) {
          this.counterMessage = false
          this.showResendBtn = true
          clearInterval(interval)
        }
      }, 1000)
    },
    onCaptchaVerified (res) {
      // console.log('onCaptchaVerified >> ', res)
      if (res && res.length) {
        this.recaptcha_response = res
        this.verifyEmail()
      } else {
        this.color = 'error'
        this.message = 'Error in verifying the reCAPTCHA'
        this.alert = true
      }
    },
    onCaptchaExpired (res) {
      this.recaptcha_response = ''
      this.$refs.recaptcha.reset()
    },
    initiateEmailVerification () {
      this.$refs.recaptcha.execute()
    },
    verifyEmail () {
      // console.log('token :: ', this.recaptcha_response)
      if (this.recaptcha_response && this.verificationCodeValid) {
        let reqBody = {
          'email': this.user_email,
          'tempPassword': this.emailVerifyCode,
          'g-recaptcha-response': this.recaptcha_response
        }
        this.$store.dispatch('ACTION_VERIFY_EMAIL', reqBody).then((res) => {
          if (!res.success) {
            this.color = 'error'
            this.message = res.error.internalMessage || res.error.message || 'Verification link invalid/expired. Please try to resend the verification link.'
            this.alert = true
            setTimeout(() => {
              this.$router.push('/signup')
            }, 3000)
          } else if (res.success && res.result && res.result.verified) {
            this.emailVerified = true
            this.emailVerificationRes = res.result
            if (!this.isMobileRequired && this.emailVerified) {
              let obj = { ...res.result, emailVerified: this.emailVerified }
              this.$router.push({ name: 'SetPassword', params: obj })
            }
          }
        })
      }
    },
    verifyOTP () {
      this.$set(this.emailVerificationRes, 'otp', this.OTP)
      this.$store.dispatch('ACTION_VERIFY_OTP', this.emailVerificationRes).then(res => {
        if (!res.success) {
          this.color = 'error'
          this.message = res.error.message || 'OTP expired.'
          this.alert = true
        } else if (res.success && res.result.verified) {
          let obj = { ...res.result, mobileVerified: true, emailVerified: this.emailVerified }
          this.$router.push({ name: 'SetPassword', params: obj })
        }
      })
    },
    resendOTP () {
      this.$store.dispatch('ACTION_RESEND_SIGNUP_OTP', { ...this.emailVerificationRes }).then(res => {
        if (!res.success) {
          this.color = 'error'
          this.message = res.error.message || 'Something went wrong.'
          this.alert = true
        } else {
          this.color = 'success'
          this.message = 'OTP sent successfully.'
          this.alert = true
        }
      })
      this.counterMessage = true
      this.countDown = this.counterTime
      this.showResendBtn = false
      this.otpTimer()
    }
    // resendVerificationLink () {
    //   this.$store.dispatch('ACTION_RESEND_EMAIL', this.errorMeta).then((res) => {
    //     if (!res.success) {
    //       this.color = 'error'
    //       this.message = res.error.message || 'Something went wrong.'
    //       this.alert = true
    //     } else {
    //       this.color = 'success'
    //       this.message = 'Verification email sent, Please check your inbox.'
    //       this.alert = true
    //       this.remainingAttempts = res.result.metaData ? res.result.metaData.remainingAttempts : undefined
    //       if (this.remainingAttempts !== undefined) {
    //         this.remaining = true
    //       }
    //     }
    //   })
    // }
  }
}
</script>

<style>
.verification-link {
  margin-top: 20vh
}
</style>
